import useStore from '../../stores/useStore';

/**
 * Error/notice banner for the menu screens. A 401 ('auth') offers re-sign-in
 * (back to PIN entry; the owner sign-in follows there if the device token is
 * gone too). The sample-menu message is informational, not an error.
 */
export default function MenuErrorBanner({ error }) {
    if (!error) return null;
    const sample = error.kind === 'sample';
    return (
        <div
            role={sample ? 'status' : 'alert'}
            className={`rounded-lg border px-4 py-3 text-sm flex flex-wrap items-center gap-3 ${
                sample ? 'bg-amber-50 border-amber-300 text-amber-900' : 'bg-red-50 border-red-300 text-red-800'
            }`}
        >
            <span className="flex-1 min-w-[12rem]">{error.message}</span>
            {error.kind === 'auth' && (
                <button
                    type="button"
                    onClick={() => useStore.getState().expireStaffSession()}
                    className="px-3 py-1.5 rounded-lg bg-red-700 text-white font-semibold focus:outline-none focus:ring-2 focus:ring-red-400"
                >
                    Sign in again
                </button>
            )}
        </div>
    );
}
